import React, { Component } from 'react';

import Template from '../_core/components/Template';

import CookieManager from '../_core/components/Cookie/CookieManager';

// Models
import {Asset,Entry,Data} from '../_core/models';

// Project
import * as Project from '../components';



class Default extends Component {

	constructor(props) {
		super(props);
	}

	componentDidMount() {

	}

	componentWillUnmount() {

	}

	/*

		RENDER

	*/

	render() {

		

		return (
			
			<Template modifiers={["basic"]}>

				<CookieManager  optionalCookies={
              	[
	                {
	                  name : 'Facebook Pixel (_fbp/fr)',
	                  description : 'This Cookie connects your visit to this site to the Facebook servers to help us to measure the performance of advertising campaigns, to serve and measure advertisements across different browsers and devices used by the same person. To opt out, visit https://www.facebook.com/ads/preferences',
	                  expiry : '180 Days'
	                }
	                
              	]
            } />

			</Template>
		
		);

	}
}

export default Default;



// WEBPACK FOOTER //
// ./src/js/templates/cookies.js